import React from 'react';
import '../App.css';

function PriestServices() {
    return (
        <div class="home-container" style={{ padding:'40px' }}>
        <div class="card1">
            <div class="title">Pooja Services</div>
            <div style={{ padding:'10px', textAlign: 'center' }}>
    <i>Note: Please contact Temple for below services details <br></br> <b>CONTACT:</b> +1 778-780-1914&nbsp;&nbsp; or <br></br><b>EMAIL:</b> info@yogahanuman.org</i>
  </div>   
            <div class="card-grid1">
          <div class="event-card" style={{ backgroundColor: '#F9E076' }}>
            <h3>GANAPATHY HOMAM</h3>
            <p class="p2">How is Ganapathi Homam performed? Install the Ganesha idol and chant mantras for invoking Lord Ganapathi. 
                Take a sip of the holy water for the inner purification of body and soul and sprinkle water on oneself.
                 Perform sankalpam and take the blessings of lord agni (fire god) by lighitng up the homakundam</p>
            </div>
          <div class="event-card" style={{ backgroundColor: '#F5EB9A' }}>
          <h3>PUNYAHAVACHANAM</h3>
            <p class="p2">Punyahavachanam involves cleansing the house; purifying it by performing Ganapathy pooja, Kalasha pooja and Chanted the mantras to invoke the power in the water.
                 This purified water is sprinkled especially on babies, parents, and everyone in the house. Prokshanam is done on all parts of the house.</p>
            </div>
          <div class="event-card" style={{ backgroundColor: '#F5EB9A' }}>
          <h3>GRUHAPRAVESHAM</h3>
            <p class="p2">Griha Pravesh Pooja is an extremely sacred ceremony to seek blessings from the Indian Gods and Goddesses, safeguard the home, and fill it with positive energies. 
                This ceremony should be performed on an auspicious day and before entering the new home; it is one of the vital components of Griha Pravesh dos and don'ts.</p>
            </div>
          <div class="event-card" style={{ backgroundColor: '#F9E076' }}>
          <h3>AAYUSH HOMAM</h3>
            <p class="p2">Ayushya means lifespan in Sanskrit. Ayush homam is the worship of Ayur Devatha (God of life). By performing this ayush homam, one is blessed with good health and long life. 
                As mentioned in Bodhayana sutras, if a child is falling ill often, this homam could be performed regularly until the child gets better</p>
            </div>
          
          <div class="event-card" style={{ backgroundColor: '#F9E076' }}>
          <h3>SEEMANTHAM</h3>
          <p class="p2">The fifth, seventh, or ninth month of pregnancy is when it is done. One of the 16 Hindu samskaras, 
          or “simantonnayana” in Sanskrit, is called Seemantham. 
          It is a samskara of the developing embryo or fetus inside the womb of the expectant mother.</p>
          <p class="p2">In other words it is a traditional baby shower function</p>
            </div>
          <div class="event-card" style={{ backgroundColor: '#F5EB9A' }}>
          <h3>SRI SATHYANARAYANA POOJA</h3>
          <p class="p2">Narayana means the one that abides in everything and everybody. Therefore, this puja, or the worship of Satyanarayan, a form of the Lord Vishnu, suggests that to overcome 
            problems and difficulties in life caused either due to deeds of previous birth or similar factors can be overcome by worshipping the lord of Truth</p>
         </div>
         <div class="event-card" style={{ backgroundColor: '#F5EB9A' }}>
          <h3>SRI MAHALAKSHMI POOJA</h3>
          <p class="p2">Give a holy bath to the idols of Laxmi and Ganesh with pure water, panchamrit (fruit salad in honey), sandal water, rose water and pure water to complete the cycle. 
            Decorate the idols with turmeric powder, sandal paste and sindhoor. Decorate the idols with flowers and garlands</p>
         </div>
         <div class="event-card" style={{ backgroundColor: '#F9E076' }}>
          <h3>SRI NAVAGRAHA HOMAM</h3>
          <p class="p2">The Navagraha Shanti Puja is a comprehensive and potent Puja performed to invoke the blessings of the nine planets – Surya (sun), Chandra (moon), Mangal (Mars), 
            Budha (Mercury), Bruhaspathi (Jupiter), Shukra (Venus), Shani (Saturn), Rahu (North lunar node), Ketu (South lunar node)</p>
           </div>
        <div class="event-card" style={{ backgroundColor: '#F9E076' }}>
          <h3>VEDA PARAYANAM</h3>
          <p class="p2">Veda parayanam is performed by Vedic priests by chanting the Shlokas and Mantras from the Four Vedas – Rig Veda, Yajur Veda, Sama Veda, and Atharva Veda</p>
         </div>
         <div class="event-card" style={{ backgroundColor: '#F5EB9A' }}>
          <h3>MAHA SUDARSHANA HOMAM</h3>
          <p class="p2">Maha Sudarshana Homam is the Hindu ritual celebrated by Hindu devotees to appease Lord Sudarshana. Maha Sudarshana Homam is performed to remove all difficulties and
             negative energies to achieve victory and success, attain good health and wealth, prosperity, and bring harmony to family and victory in the venture</p>
         </div>
         <div class="event-card" style={{ backgroundColor: '#F5EB9A' }}>
          <h3>ANNAPRASANA</h3>
          <p class="p2">The annaprashana, also known as annaprashana vidhi or annaprashanam, is a Hindu rite of passage (Saṃskāra) that marks an infant's first 
            intake of food other than milk. The term annaprashana means 'eating of cooked rice'.</p>
         </div>
         

         <div style={{ padding:'10px', textAlign: 'center' }}>
    <i>Note: Please contact Temple for below services details <br></br> <b>CONTACT:</b> +1 778-780-1914&nbsp;&nbsp; or <br></br><b>EMAIL:</b> info@yogahanuman.org</i>
  </div>   
        </div>
      {/* Add page content */}
      </div>
    </div>
  );
};

export default PriestServices;